import api_base, { serializeParams } from "./base";
import { 
  TemplateRequest, 
  CreateTemplateRequestPayload, 
  UpdateTemplateRequestPayload,
  TemplateRequestListParams 
} from "@/types/template-request";

export const list_my_requests = async (params?: TemplateRequestListParams) => {
  const response = await api_base.get<{
    results: TemplateRequest[];
    count: number;
  }>("/api/v1/template-requests/", {
    params,
    paramsSerializer: serializeParams,
  });
  return response.data;
};

export const create_template_request = async (data: CreateTemplateRequestPayload) => {
  const formData = new FormData();
  formData.append("file", data.file);
  if (data.description) {
    formData.append("description", data.description);
  }

  const response = await api_base.post<TemplateRequest>(
    "/api/v1/template-requests/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

export const list_all_requests = async (params?: TemplateRequestListParams) => {
  // Super admin endpoint is the same base URL, usually permission based filtering on backend
  const response = await api_base.get<{
    results: TemplateRequest[];
    count: number;
  }>("/api/v1/template-requests/", {
    params,
    paramsSerializer: serializeParams,
  });
  return response.data;
};

export const update_template_request_status = async (
  id: string,
  data: UpdateTemplateRequestPayload
) => {
  const response = await api_base.patch<TemplateRequest>(
    `/api/v1/template-requests/${id}/`,
    data
  );
  return response.data;
};
